import React from 'react';
import { InstructorCard } from './InstructorCard';
import { instructors } from '../../data/instructors';
export function InstructorGrid() {
  return <section className="py-16 bg-white" data-id="element-397">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-398">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-399">
          {instructors.map(instructor => <InstructorCard key={instructor.id} instructor={instructor} data-id="element-400" />)}
        </div>
      </div>
    </section>;
}